module.exports = __webpack_public_path__ + "img/IT0000101246006.00abe466.png";